import { svg as e } from "lit";
import { IDSIconBase as t } from "../icon-base-element.js";
class r extends t {
  constructor() {
    super(), this.vbHeight = 10, this.vbWidth = 5;
  }
  renderIcon() {
    return e`<path fill="${this.colors.color}" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M5.45327 4.54673C5.70361 4.79706 5.70361 5.20294 5.45327 5.45327L1.0943 9.81225C0.843963 10.0626 0.438088 10.0626 0.187752 9.81225C-0.062584 9.56191 -0.062584 9.15604 0.187752 8.9057L4.09345 5L0.187752 1.0943C-0.0625836 0.843963 -0.0625836 0.438088 0.187752 0.187752C0.438089 -0.062584 0.843963 -0.062584 1.0943 0.187752L5.45327 4.54673Z"></path>`;
  }
}
export { r as IDSIconChevron };